const routes = {
  "/": "Home",
  // "/home": "",
  // '/home': 'My Dashboard',
  "/dashboard": "Global Content",
  // '/latest': 'My Content',
  "/latest/detail": "Content Detail",
  "/logs": "Logs",
  "/new-regulator": "New Regulator",
  "/regulators": "Regulators",
  "/regulators/detail": "Detail",
  "/unmatched": "Unmatched Enforcements",
  "/change-password": "Change Password",
  "/search-manage": "Saved Search Management",
  "/filters-create": "Create View",
  "/filters-edit": "Update View",

  "/regulator-notices/create": "Create Notice",
  "/regulator-notices/search": "Search Notices",

  "/doc-inbox": "Regulatory Inbox",

  "/alerting": "Alerts",
  "/alerting-edit": "Update Alert",
  "/alerting-create": "Create Alert",
  "/all-activity": "All Activity",
  "/my-queue": "My Queue",
  "/corlytics-updates": "Corlytics Updates",
  "/supervisor-assign": "Supervisor Assign",
  "/document-details": "Document Details",

  "/wfsetup/auto-assign/create": "Create Auto-Assign Rule",
  "/wfsetup/escalation/create": "Create Escalation Rule",

  "/service-lines-mapping": "Service Lines Mapping",

  "/workflows": "Workflows",
  "/workflows/edit": "Edit Workflow",

  "/admin/clients": "Clients",
  "/admin/clients/new": "New Client",
  "/admin/clients/edit": "Edit Client",
  "/admin/users": "Users",
  "/admin/users/new": "New User",
  "/admin/users/edit": "Edit User",
  "/admin/roles": "Roles",
  "/admin/roles/new": "New Role",

  "/user/notifications/Inbox": "Notifications - My Inbox",
  "/user/notifications/Sent Items": "Notifications - Sent Items",
  "/user/notifications/Deleted Items": "Notifications - Deleted Items",
  "/user/notifications/Important": "Notifications - Important",
  "/user/notifications/Starred": "Notifications - Starred",

  "/tasks": "My Tasks",
  "/all-tasks/list": "Tasks",

  "/assessments": "My Assessments",
  "/all-assessments": "All Assessments",
  "/assessments/new": "Create Assessment",
  "/assessments/edit": "Update Assessment",

  "/marketing-notices/list": "Marketing Notices",
  "/marketing-notices/edit/": "Edit Marketing Notices",

  "/search": "Search",

  "/sl-autotags": "Auto Tag Manager List",
  "/sl-autotag/create/:search_id?": "Auto Tag Manager",

  "/regulation": "Laws and Rulebooks",

  "/regulation-books/:regulatorId/": "Regulations",
  "/books/:bookId/sections": "Sections",
  "/chapters/:chapterId": "Chapter Blocks",

  "/controlled-job-functions": "Controlled Job Functions",
  "/clients/organisations-edit": "Edit Organisation",
  "/clients/organisations-roles": "Organisation Roles",
  "/clients/organisations-roles-edit": "Edit Role",
  "/clients/organisations": "Client Organisations",

  "/verify-compliance-form": "Compliance Confirmation",
  "/risk-outlook": "Risk Outlook",
  "/usage/client-views": "Usage Reporting",
  "/models/create": "New Model",
  "/models/update/": "Update Model",
  "/models": "Models",
  "/covid": "Covid-19 Tracker",

  "/loss-report": "Report Details",
  "/loss-report-list": "Reports",

  "/rri": "Risk Heatmaps",
  "/fines-list": "Enforcements",
  "/fine-details": "Enforcement Details",
  "/controls-analysis": "Controls Analysis",
  "/regulation-profiler": "Regulation Profiler",
  "/tutorials": "Tutorials",
  "/preferences": "Settings",
  "/regulatory-analysis": "Regulatory Analysis",

  "/watchlist": "Regulation Watch List",
  "/api-viewer/authorities": 'Api Viewer Authorities',
  "/api-viewer/regulations/:id/:title": 'Api Viewer Regulations',
  "/api-viewer/versions/:id/:title": 'Api Viewer Versions',
  "/api-viewer/content/:id": 'Api Viewer Content',
  "/workflow-routing/:id": "Workflow Routing Maintain",
  "/workflow-routing": "Workflow Routing",
  "/auto-tasks/:id": "Auto Tasks Maintain",
  "/auto-tasks": "Auto Tasks",
  "/user-groups": "User Groups",
  "/user-groups/create": "Create User Group",
  "/user-groups/update/:id": "Update User Group",
  "/legal-entities": "Legal Entities",
  "/queues": "My Queues",
  "/finra-visualisation/:id": "FINRA Visualisation",
  "/finra-visualisation": "FINRA Visualisation",
  "/finra-rules/:id": "Regulatory Tagging Tool",
  "/finra-rules": "Regulatory Tagging Tool",
  "/esg-tracker": "ESG Tracker",
  "/push-api": "Push API",
  "/procedures": "Procedures",
  "/procedures-watchlist": "Procedures Watchlist"
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js